import { FatalErrorBoundary } from '@redwoodjs/web'
import { RedwoodApolloProvider } from '@redwoodjs/web/apollo'
import DefaultLayout from 'src/layouts/DefaultLayout'

import FatalErrorPage from 'src/pages/FatalErrorPage'
import Routes from 'src/Routes'

import './index.css'

const App = () => (
  <FatalErrorBoundary page={FatalErrorPage}>
    <RedwoodApolloProvider>
      <DefaultLayout>
        <Routes />
      </DefaultLayout>
    </RedwoodApolloProvider>
  </FatalErrorBoundary>
)

export default App
